<div class="p-4 md:p-6 w-full">

  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center">
    <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance_wallet</mat-icon>
    Dashboard Binance Link
    <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
      {{ totalItems }} registros
    </span>
  </h1>
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
    {{ totalItems }} registros
  </span>

  <!-- ─── Acciones sensibles del operador (gating por CORREOS_AUT) ─── -->
  <div *ngIf="canDeleteBinanceSub" class="mt-3 flex flex-wrap items-center gap-2">
    <button title="Eliminar sub-cuenta Binance por subAccountId"
      (click)="openDeleteBinanceSubModal()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 14px; background: white; color: #b91c1c; border: 1px solid #fca5a5; border-radius: 8px; font-weight: 700; font-size: 0.8rem; cursor: pointer; transition: background 0.2s ease;"
      onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='white'">
      <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #b91c1c;">delete_forever</mat-icon>
      Eliminar sub-cuenta Binance
    </button>
    <span style="font-size: 0.7rem; color: #9ca3af; font-style: italic;">
      Acción restringida — solo operadores autorizados.
    </span>
  </div>

  <!-- ============ CARD: CUENTA MASTER + SYNC ============ -->
  <div *ngIf="dashboard" class="mt-4 bg-white p-4 md:p-5 rounded-xl shadow-md border border-gray-100">
    <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-3">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D;">hub</mat-icon>
        <span class="text-base font-bold text-gray-800">Cuenta master</span>
        <span class="px-2 py-0.5 inline-flex text-xs font-bold rounded-full"
          [style.background]="getSyncStatusBg(dashboard.master.lastSyncStatus)"
          [style.color]="getSyncStatusColor(dashboard.master.lastSyncStatus)">
          {{ dashboard.master.lastSyncStatus }}
        </span>
      </div>
      <div class="flex items-center gap-2">
        <span class="text-xs text-gray-500">Última sync: {{ getRelativeTime(dashboard.master.lastSyncedAt) }}</span>
        <button (click)="onSyncNow()" [disabled]="isSyncing"
          [style.opacity]="isSyncing ? '0.5' : '1'"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">sync</mat-icon>
          {{ isSyncing ? 'Sincronizando...' : 'Sincronizar ahora' }}
        </button>
      </div>
    </div>

    <!-- Saldos master (spot only - funding sigue por Telegram) -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4">
      <div class="rounded-lg p-3 border border-green-100" style="background: #f0fdf4;">
        <div class="flex items-center justify-between">
          <span class="text-xs text-gray-600 font-semibold">USDT spot</span>
          <span class="text-[10px] text-gray-400">free + locked</span>
        </div>
        <p class="text-2xl font-bold mt-1" style="color: #15803d;">
          {{ formatUsd(dashboard.master.balances.usdt) }}
          <span class="text-sm font-normal text-gray-500">USDT</span>
        </p>
        <!-- Sparkline: evolucion del saldo USDT en el ring buffer (~24h) -->
        <ng-container *ngIf="hasSparkData; else sparkEmpty">
          <svg [attr.width]="sparkWidth" [attr.height]="sparkHeight"
            [attr.viewBox]="'0 0 ' + sparkWidth + ' ' + sparkHeight"
            style="margin-top: 4px; display: block; max-width: 100%;">
            <polyline [attr.points]="sparkPoints"
              fill="none" stroke="#15803d" stroke-width="1.5"
              stroke-linejoin="round" stroke-linecap="round" />
          </svg>
          <div class="flex items-center justify-between text-[10px] text-gray-400 mt-0.5">
            <span [title]="'Mínimo en el rango graficado'">min {{ formatUsd(sparkMin?.toString() ?? null) }}</span>
            <span>{{ historySnapshots.length }}/{{ historyCapacity }} snapshots</span>
            <span [title]="'Máximo en el rango graficado'">max {{ formatUsd(sparkMax?.toString() ?? null) }}</span>
          </div>
        </ng-container>
        <ng-template #sparkEmpty>
          <p class="text-[10px] text-gray-400 mt-1" title="Tras un deploy del backend el buffer arranca vacío y se va llenando con cada sync (cada 5 min). Para histórico completo: CloudWatch Insights con filtro BINANCE_LINK_MASTER_SNAPSHOT.">
            Esperando datos del timeline…
          </p>
        </ng-template>
      </div>
      <div class="rounded-lg p-3 border border-orange-100" style="background: #fff7ed;">
        <div class="flex items-center justify-between">
          <span class="text-xs text-gray-600 font-semibold">BTC spot</span>
          <span class="text-[10px] text-gray-400" *ngIf="dashboard.master.balances.btcUsdtPrice"
            [title]="'BTC/USDT al sync: ' + formatUsd(dashboard.master.balances.btcUsdtPrice)">
            @ {{ formatUsd(dashboard.master.balances.btcUsdtPrice) }}
          </span>
        </div>
        <p class="text-2xl font-bold mt-1" style="color: #c2410c;">
          {{ formatBtc(dashboard.master.balances.btc) }}
          <span class="text-sm font-normal text-gray-500">BTC</span>
        </p>
      </div>
      <div class="rounded-lg p-3 border border-gray-200" style="background: #f9fafb;">
        <div class="flex items-center justify-between">
          <span class="text-xs text-gray-600 font-semibold">Total USD eq.</span>
          <span class="text-[10px] text-gray-400"
            [title]="'Solo spot. Funding NO incluido — ver alertas Telegram.'">
            spot
          </span>
        </div>
        <p class="text-2xl font-bold mt-1 text-gray-800">
          ${{ formatUsd(dashboard.master.balances.totalUsd) }}
        </p>
        <span class="text-[10px] text-gray-400" *ngIf="dashboard.master.balances.syncedAt">
          {{ getRelativeTime(dashboard.master.balances.syncedAt) }}
        </span>
      </div>
    </div>

    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
      <div>
        <span class="text-gray-500 font-semibold">Sub-cuentas</span>
        <p class="text-base font-bold text-gray-800">
          {{ dashboard.master.subAccountQty ?? '—' }}
          <span class="text-xs font-normal text-gray-500">/ {{ dashboard.master.maxSubAccountQty ?? '—' }}</span>
        </p>
      </div>
      <div>
        <span class="text-gray-500 font-semibold">Maker spot</span>
        <p class="text-base font-bold text-gray-800">
          {{ formatCommission(dashboard.master.minMakerCommission) }} – {{ formatCommission(dashboard.master.maxMakerCommission) }}
        </p>
      </div>
      <div>
        <span class="text-gray-500 font-semibold">Taker spot</span>
        <p class="text-base font-bold text-gray-800">
          {{ formatCommission(dashboard.master.minTakerCommission) }} – {{ formatCommission(dashboard.master.maxTakerCommission) }}
        </p>
      </div>
      <div *ngIf="dashboard.master.lastSyncStatus === 'ERROR'">
        <span class="text-gray-500 font-semibold">Error sync</span>
        <p class="text-xs text-red-700 truncate" [title]="dashboard.master.lastSyncError">
          {{ dashboard.master.lastSyncError }}
        </p>
      </div>
    </div>
  </div>

  <!-- ============ KPI CARDS LOCALES ============ -->
  <div *ngIf="dashboard" class="mt-4 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
    <div class="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
      <span class="text-xs text-gray-500 font-semibold">Activas</span>
      <p class="text-xl font-bold" style="color: #15803d;">{{ dashboard.aggregates.totalActive }}</p>
    </div>
    <div class="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
      <span class="text-xs text-gray-500 font-semibold">Deshabilitadas</span>
      <p class="text-xl font-bold text-gray-700">{{ dashboard.aggregates.totalDisabled }}</p>
    </div>
    <div class="bg-white p-3 rounded-xl shadow-sm border border-gray-100"
      [style.border-color]="dashboard.aggregates.errorCount > 0 ? '#dc2626' : '#e5e7eb'">
      <span class="text-xs text-gray-500 font-semibold">En ERROR</span>
      <p class="text-xl font-bold" [style.color]="dashboard.aggregates.errorCount > 0 ? '#dc2626' : '#6b7280'">
        {{ dashboard.aggregates.errorCount }}
      </p>
    </div>
    <div class="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
      <span class="text-xs text-gray-500 font-semibold">KYC PASS</span>
      <p class="text-xl font-bold" style="color: #15803d;">{{ dashboard.aggregates.byKycStatus.PASS }}</p>
    </div>
    <div class="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
      <span class="text-xs text-gray-500 font-semibold">KYC pendiente</span>
      <p class="text-xl font-bold" style="color: #a16207;">{{ dashboard.aggregates.byKycStatus.PENDING + dashboard.aggregates.byKycStatus.NONE }}</p>
    </div>
    <div class="bg-white p-3 rounded-xl shadow-sm border border-gray-100">
      <span class="text-xs text-gray-500 font-semibold">Creadas hoy</span>
      <p class="text-xl font-bold" style="color: #1e5a3f;">{{ dashboard.aggregates.createdToday }}</p>
    </div>
  </div>

  <!-- ============ CARD: PREVALIDACIÓN KYC INTERNA ============ -->
  <!-- Sincronización masiva: corre revalidate(usuarioId) sobre todo el
       universo del listado con worker async interno. NO toca Binance
       KYC SaaS — sólo valida internamente face match + OCR vs User.

       Card SIEMPRE visible (sin *ngIf) — si el backend falla muestra
       banner de error + botón disabled, así el operador ve que existe
       la funcionalidad y por qué no anda. -->
  <div class="mt-4 bg-white p-4 md:p-5 rounded-xl shadow-md border border-gray-100">
    <div class="flex items-center justify-between gap-3 mb-3 flex-wrap">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D;">verified_user</mat-icon>
        <span class="text-base font-bold text-gray-800">Prevalidación KYC interna</span>
        <span *ngIf="prevalidacion?.isRunning"
          class="px-2 py-0.5 inline-flex text-xs font-bold rounded-full"
          style="background: #dbeafe; color: #1e40af;">
          ⏳ Sincronizando
        </span>
        <span *ngIf="prevalidacionLoading"
          class="text-xs text-gray-500 italic">
          Cargando estado...
        </span>
      </div>
      <button (click)="onStartPrevalidacionSync()"
        [disabled]="prevalidacion?.isRunning || prevalidacionLoading || !!prevalidacionLoadError"
        [style.opacity]="(prevalidacion?.isRunning || prevalidacionLoading || prevalidacionLoadError) ? '0.5' : '1'"
        [style.cursor]="(prevalidacion?.isRunning || prevalidacionLoading || prevalidacionLoadError) ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #1C593D; color: white; border: none; border-radius: 8px; font-weight: 600; font-size: 0.8rem;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">play_arrow</mat-icon>
        {{ prevalidacion?.isRunning ? 'Sincronizando...' : 'Sincronizar prevalidación' }}
      </button>
    </div>

    <!-- Banner de error (cuando el endpoint backend falla) -->
    <div *ngIf="prevalidacionLoadError" class="mb-3 p-3 rounded-lg border border-red-200" style="background: #fef2f2;">
      <p class="text-xs font-bold" style="color: #b91c1c;">
        ⚠ No se pudo cargar el estado de prevalidación
      </p>
      <p class="text-[11px] mt-1" style="color: #991b1b;">{{ prevalidacionLoadError }}</p>
      <p class="text-[10px] mt-1 text-gray-600">
        Verificá: (1) backend con la última versión deployada, (2) tabla
        <code>binance_link_prevalidacion_jobs</code> creada en la BD.
      </p>
    </div>

    <!-- 4 KPIs globales (sobre la BD, no del job) — resilientes a null -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-3">
      <div class="rounded-lg p-3 border border-blue-100" style="background: #eff6ff;">
        <span class="text-xs text-gray-600 font-semibold">📋 Pre-validados</span>
        <p class="text-2xl font-bold mt-1" style="color: #1e40af;">
          {{ prevalidacion?.globalCounters?.preValidados ?? '—' }}
          <span class="text-xs font-normal text-gray-500">/ {{ prevalidacion?.globalCounters?.totalEligibles ?? '—' }}</span>
        </p>
      </div>
      <div class="rounded-lg p-3 border border-green-100" style="background: #f0fdf4;">
        <span class="text-xs text-gray-600 font-semibold">✓ Óptimos</span>
        <p class="text-2xl font-bold mt-1" style="color: #15803d;">
          {{ prevalidacion?.globalCounters?.optimos ?? '—' }}
          <span class="text-xs font-normal text-gray-500">{{ prevalidacionOptimosPct() }}</span>
        </p>
        <span class="text-[10px] text-gray-500">face + OCR OK</span>
      </div>
      <div class="rounded-lg p-3 border border-orange-100" style="background: #fff7ed;">
        <span class="text-xs text-gray-600 font-semibold">⚠ Mismatch</span>
        <p class="text-2xl font-bold mt-1" style="color: #c2410c;">
          {{ prevalidacion?.globalCounters?.noOptimos ?? '—' }}
        </p>
        <span class="text-[10px] text-gray-500">face fail O datos no coinciden</span>
      </div>
      <div class="rounded-lg p-3 border border-red-100" style="background: #fef2f2;">
        <span class="text-xs text-gray-600 font-semibold">🚫 Bloqueados</span>
        <p class="text-2xl font-bold mt-1" style="color: #b91c1c;">
          {{ prevalidacion?.globalCounters?.bloqueados ?? '—' }}
        </p>
        <span class="text-[10px] text-gray-500">faltan selfie / foto</span>
      </div>
    </div>

    <!-- Progress bar / resumen del run con alias `job` para narrowing.
         Angular strict template no narrowea `prevalidacion?.lastJob`
         automáticamente; el `as job` lo deja non-null dentro del bloque. -->
    <ng-container *ngIf="prevalidacion?.lastJob as job">
      <!-- Progress bar mientras corre -->
      <div *ngIf="prevalidacion?.isRunning" class="mt-3 p-3 rounded-lg border border-blue-100" style="background: #f0f9ff;">
        <div class="flex items-center justify-between text-xs text-gray-700 mb-2">
          <span class="font-semibold">
            ⏳ Sincronizando · {{ job.totalProcessed }} / {{ job.totalEnqueued }}
          </span>
          <span class="font-bold" style="color: #1e40af;">{{ prevalidacionProgressPct() }}%</span>
        </div>
        <div class="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
          <div class="h-full transition-all duration-500"
            style="background: #1C593D;"
            [style.width.%]="prevalidacionProgressPct()">
          </div>
        </div>
        <div class="flex flex-wrap gap-3 text-[11px] text-gray-600 mt-2">
          <span>Live · ✓ {{ job.totalOptimos }}</span>
          <span>⚠ {{ job.totalNoOptimos }}</span>
          <span>🚫 {{ job.totalBloqueados }}</span>
          <span>⏭ {{ job.totalSkipped }} omitidos (&lt;24h)</span>
          <span *ngIf="job.totalErrored > 0" style="color: #b91c1c;">
            ⚠ {{ job.totalErrored }} errores
          </span>
        </div>
      </div>

      <!-- Resumen del último run (cuando NO está corriendo) -->
      <div *ngIf="!prevalidacion?.isRunning" class="mt-2 text-[11px] text-gray-500 flex items-center gap-3 flex-wrap">
        <span>
          Última sincronización: {{ getRelativeTime(job.completedAt ?? job.lastProgressAt) }}
          ({{ getDateFormatted(job.completedAt ?? job.lastProgressAt) }})
        </span>
        <span>·</span>
        <span>Procesó {{ job.totalProcessed }}</span>
        <span>· ✓ {{ job.totalOptimos }}</span>
        <span>· ⚠ {{ job.totalNoOptimos }}</span>
        <span>· 🚫 {{ job.totalBloqueados }}</span>
        <span>· ⏭ {{ job.totalSkipped }} omitidos</span>
        <span *ngIf="job.totalErrored > 0" style="color: #b91c1c;">
          · ⚠ {{ job.totalErrored }} errores
        </span>
      </div>
    </ng-container>

    <!-- Mensaje cuando no hay job todavía (status cargado pero sin lastJob) -->
    <div *ngIf="prevalidacion && !prevalidacion.lastJob && !prevalidacionLoadError" class="mt-2 text-[11px] text-gray-500 italic">
      Nunca se sincronizó. Click en "Sincronizar prevalidación" para validar todos los usuarios elegibles del listado.
    </div>
  </div>

  <!-- Filtros y acciones -->
  <div class="flex justify-center mt-6">
    <div class="w-full max-w-5xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <div class="flex items-center gap-2 mb-4">
        <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">filter_list</mat-icon>
        <span class="text-sm font-semibold" style="color: #1e5a3f;">Filtros</span>
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
        <div class="filter-group sm:col-span-2">
          <label class="filter-label">Buscar usuario</label>
          <input type="text" [(ngModel)]="filterQ"
            (keyup.enter)="applyFilters()"
            placeholder="Email, nombre, apellido o número de documento" class="filter-input" />
        </div>

        <div class="filter-group">
          <label class="filter-label">Filtro</label>
          <select [(ngModel)]="filterHasWallet" class="filter-input">
            <option *ngFor="let opt of hasWalletOptions" [ngValue]="opt.value">{{ opt.label }}</option>
          </select>
        </div>
      </div>

      <div class="flex flex-col sm:flex-row gap-2 justify-end">
        <button type="button" (click)="clearFilters()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
          Limpiar
        </button>
        <button type="button" (click)="applyFilters()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>

  <!-- Paginator -->
  <div class="flex justify-center mt-4">
    <mat-paginator
      class="demo-paginator"
      (page)="onPageChange($event)"
      [length]="totalItems"
      [pageSize]="pageSize"
      [showFirstLastButtons]="true"
      [pageSizeOptions]="[5, 10, 20, 50, 100]"
      [pageIndex]="currentPage - 1"
      aria-label="Seleccionar página">
    </mat-paginator>
  </div>

  <!-- ============ TABLA DESKTOP ============ -->
  <div class="hidden lg:block mt-4 overflow-x-auto rounded-xl shadow-lg border border-gray-100">
    <table mat-table [dataSource]="users" class="w-full">

      <!-- Usuario (ID + tipo + nombre / razon social + prevalidación KYC) -->
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Usuario</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; flex-direction: column; gap: 3px;">
            <div class="flex items-center gap-1.5">
              <span class="text-xs text-gray-500 font-mono">#{{ row.usuarioId }}</span>
              <span class="px-1.5 py-0.5 text-[9px] font-bold rounded uppercase tracking-wide"
                [style.background]="isEmpresa(row) ? '#fef3c7' : '#dbeafe'"
                [style.color]="isEmpresa(row) ? '#92400e' : '#1e40af'">
                {{ isEmpresa(row) ? 'Empresa' : 'Persona' }}
              </span>
            </div>
            <span class="font-semibold text-gray-800 text-xs">{{ displayName(row) }}</span>

            <!-- Prevalidación KYC interna: sólo para usuarios sin wallet
                 (decisión previa a crear la sub). Una vez creada, su KYC
                 de verdad lo refleja la columna `kycStatus` de Binance. -->
            <div *ngIf="!row.walletId" style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap; margin-top: 2px;">
              <ng-container *ngIf="prevalidationBadge(row) as badge">
                <span class="text-[9px] uppercase tracking-wide text-gray-500 font-semibold">Prevalidación:</span>
                <span class="px-2 py-0.5 inline-flex items-center gap-1 text-[10px] leading-4 font-bold rounded-full"
                  [style.background]="badge.bg"
                  [style.color]="badge.color"
                  [title]="badge.tooltip">
                  <mat-icon style="font-size: 11px; width: 11px; height: 11px;"
                    [style.color]="badge.color">
                    {{ badge.icon }}
                  </mat-icon>
                  {{ badge.label }}
                </span>
                <button *ngIf="badge.canRevalidate"
                  (click)="onRevalidateUser(row)"
                  [disabled]="revalidatingUserId === row.usuarioId"
                  [style.opacity]="revalidatingUserId === row.usuarioId ? '0.5' : '1'"
                  [style.cursor]="revalidatingUserId === row.usuarioId ? 'wait' : 'pointer'"
                  style="display: inline-flex; align-items: center; gap: 2px; padding: 1px 6px; font-size: 0.6rem; border: 1px solid #d1d5db; border-radius: 4px; background: white; color: #374151;">
                  <mat-icon style="font-size: 10px; width: 10px; height: 10px; color: #374151;">refresh</mat-icon>
                  {{ revalidatingUserId === row.usuarioId ? 'Validando...' : 'Prevalidar' }}
                </button>
              </ng-container>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Email + RUT debajo -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email · RUT</th>
        <td mat-cell *matCellDef="let row" class="text-xs"
          style="max-width: 240px;">
          <div style="display: flex; flex-direction: column; gap: 2px;">
            <span style="color: #2563eb; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
              [title]="row.email">
              {{ row.email }}
            </span>
            <span class="font-mono text-gray-500" [title]="'RUT ' + displayRut(row)">
              RUT {{ displayRut(row) }}
            </span>
          </div>
        </td>
      </ng-container>

      <!-- País (CHILE para todos los usuarios con RUT del listado)
           + fecha de aprobación de compliance debajo -->
      <ng-container matColumnDef="pais">
        <th mat-header-cell *matHeaderCellDef>País · Aprobación</th>
        <td mat-cell *matCellDef="let row">
          <div style="display: flex; flex-direction: column; gap: 3px; align-items: flex-start;">
            <span class="font-bold px-2 py-0.5 rounded-full text-xs"
              style="background: #f1f5f9; color: #1e293b;">
              {{ displayPais(row) }}
            </span>
            <span class="text-[10px] text-gray-500"
              [title]="row.approvedAt ? 'Aprobado el ' + getDateFormatted(row.approvedAt) : 'Sin registro de aprobación en log'">
              Aprobado: {{ formatApprovalDate(row.approvedAt) }}
            </span>
          </div>
        </td>
      </ng-container>

      <!-- Saldo USDT (cardex interno Aguacate) -->
      <!-- Visible siempre, no depende de la sub-cuenta Binance Link. -->
      <ng-container matColumnDef="usdtBalance">
        <th mat-header-cell *matHeaderCellDef>Saldo USDT</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-mono"
          [style.color]="row.usdtBalance ? '#15803d' : '#9ca3af'"
          [style.fontWeight]="row.usdtBalance ? '700' : '400'"
          title="Saldo del wallet USDT interno (independiente de Binance Link)">
          <ng-container *ngIf="row.usdtBalance !== null; else noUsdtBalance">
            {{ formatUsd(row.usdtBalance) }}
          </ng-container>
          <ng-template #noUsdtBalance>—</ng-template>
        </td>
      </ng-container>

      <!-- Wallet Status (o "Sin wallet") -->
      <ng-container matColumnDef="walletStatus">
        <th mat-header-cell *matHeaderCellDef>Estado wallet</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.walletStatus" class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getWalletStatusBg(row.walletStatus)"
            [style.color]="getWalletStatusColor(row.walletStatus)">
            {{ row.walletStatus }}
          </span>
          <span *ngIf="!row.walletStatus" class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full bg-gray-100 text-gray-500">
            Sin wallet
          </span>
        </td>
      </ng-container>

      <!-- KYC Status (solo si tiene wallet) -->
      <ng-container matColumnDef="kycStatus">
        <th mat-header-cell *matHeaderCellDef>KYC</th>
        <td mat-cell *matCellDef="let row">
          <span *ngIf="row.kycStatus" class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getKycStatusBg(row.kycStatus)"
            [style.color]="getKycStatusColor(row.kycStatus)">
            {{ row.kycStatus }}
          </span>
          <span *ngIf="!row.kycStatus" class="text-gray-400 text-xs">—</span>
        </td>
      </ng-container>

      <!-- Balance BTC -->
      <ng-container matColumnDef="lastBalanceBtc">
        <th mat-header-cell *matHeaderCellDef>Balance BTC</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-mono" style="color: #1e5a3f;"
          [title]="row.lastBalanceSyncedAt ? 'Sync: ' + getDateFormatted(row.lastBalanceSyncedAt) : 'Sin sync'">
          {{ formatBtc(row.lastBalanceBtc) }}
        </td>
      </ng-container>

      <!-- Balance USDT en sub-cuenta Binance (pendiente de centralizar) -->
      <!-- Distinto de `usdtBalance` (cardex interno). -->
      <!-- "0.00000000" → "0.00" (sub sincronizada en cero), null → "—". -->
      <ng-container matColumnDef="lastBalanceUsdt">
        <th mat-header-cell *matHeaderCellDef>USDT en sub</th>
        <td mat-cell *matCellDef="let row" class="text-xs font-mono"
          [style.color]="hasPositiveSubUsdt(row) ? '#15803d' : (row.lastBalanceUsdt != null ? '#1e5a3f' : '#9ca3af')"
          [style.fontWeight]="hasPositiveSubUsdt(row) ? '700' : '400'"
          [title]="row.lastBalanceSyncedAt ? 'Sync: ' + getDateFormatted(row.lastBalanceSyncedAt) : 'Sin sync'">
          {{ formatUsd(row.lastBalanceUsdt) }}
        </td>
      </ng-container>

      <!-- Último depósito -->
      <ng-container matColumnDef="lastDepositAt">
        <th mat-header-cell *matHeaderCellDef>Último depósito</th>
        <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
          <ng-container *ngIf="row.lastDepositAt; else noDeposit">
            {{ getRelativeTime(row.lastDepositAt) }}
            <span class="text-xs text-gray-400" *ngIf="row.totalDepositsCount > 0"
              title="Depósitos en las últimas 6 h">
              ({{ row.totalDepositsCount }} recientes)
            </span>
          </ng-container>
          <ng-template #noDeposit>
            <span class="text-gray-400">—</span>
          </ng-template>
        </td>
      </ng-container>

      <!-- Acciones -->
      <ng-container matColumnDef="acciones" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let row">
          <!-- Sin wallet → solo botón crear -->
          <div *ngIf="!row.walletId" style="display: flex; justify-content: center;">
            <button title="Crear wallet Binance" (click)="openCreateWalletModal(row)"
              style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #1C593D; border-radius: 6px; background: #1C593D; color: white; cursor: pointer; font-size: 0.7rem; font-weight: 700;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: white;">add</mat-icon>
              Crear wallet
            </button>
          </div>
          <!-- Con wallet → acciones operativas -->
          <div *ngIf="row.walletId" style="display: flex; gap: 4px; justify-content: center; flex-wrap: wrap;">
            <button title="Ver detalle" (click)="openDetail(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">visibility</mat-icon>
            </button>
            <button title="Ver dirección de depósito" (click)="openDepositAddress(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #15803d;">qr_code_2</mat-icon>
            </button>
            <button title="Historial de depósitos" (click)="openDepositsHistory(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bae6fd; border-radius: 6px; background: #f0f9ff; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #0369a1;">history</mat-icon>
            </button>
            <button *ngIf="canRunManualCentralization(row)"
              title="Centralizar depósitos pendientes"
              (click)="openManualCentralizationModal(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fde68a; border-radius: 6px; background: #fffbeb; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #d97706;">sync_alt</mat-icon>
            </button>
            <button title="Deshabilitar" (click)="openDisableModal(row)"
              style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">block</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div *ngIf="users.length === 0" class="p-8 text-center text-gray-500 text-sm">
      No se encontraron usuarios con los filtros aplicados.
    </div>
  </div>

  <!-- ============ CARDS MOBILE ============ -->
  <div class="lg:hidden mt-4 space-y-3">
    <div *ngFor="let row of users"
      class="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-200"
      [style.border]="expandedCardId === row.usuarioId ? '2px solid #1C593D' : '1px solid #e5e7eb'">

      <!-- Card Header: nombre + status wallet + badge prevalidación inline -->
      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(row.usuarioId)"
        [style.background]="expandedCardId === row.usuarioId ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <div style="display: flex; flex-direction: column; min-width: 0; gap: 3px;">
            <div class="flex items-center gap-1.5">
              <span class="text-xs text-gray-500 font-mono">#{{ row.usuarioId }}</span>
              <span class="px-1.5 py-0.5 text-[9px] font-bold rounded uppercase tracking-wide"
                [style.background]="isEmpresa(row) ? '#fef3c7' : '#dbeafe'"
                [style.color]="isEmpresa(row) ? '#92400e' : '#1e40af'">
                {{ isEmpresa(row) ? 'Empresa' : 'Persona' }}
              </span>
            </div>
            <span class="font-semibold text-gray-800 text-xs truncate">{{ displayName(row) }}</span>
            <!-- Badge prevalidación inline — sólo usuarios sin wallet -->
            <ng-container *ngIf="!row.walletId && prevalidationBadge(row) as badge">
              <span class="px-2 py-0.5 inline-flex items-center gap-1 text-[10px] leading-4 font-bold rounded-full self-start"
                [style.background]="badge.bg"
                [style.color]="badge.color"
                [title]="badge.tooltip">
                <mat-icon style="font-size: 11px; width: 11px; height: 11px;"
                  [style.color]="badge.color">
                  {{ badge.icon }}
                </mat-icon>
                {{ badge.label }}
              </span>
            </ng-container>
          </div>
        </div>
        <div class="flex items-center gap-2 shrink-0">
          <span *ngIf="row.walletStatus" class="px-2 py-0.5 inline-flex text-xs leading-5 font-bold rounded-full"
            [style.background]="getWalletStatusBg(row.walletStatus)"
            [style.color]="getWalletStatusColor(row.walletStatus)">
            {{ row.walletStatus }}
          </span>
          <span *ngIf="!row.walletStatus" class="px-2 py-0.5 text-xs font-bold rounded-full bg-gray-100 text-gray-500">
            Sin wallet
          </span>
          <mat-icon style="color: #6b7280; transition: transform 0.2s ease;"
            [style.transform]="expandedCardId === row.usuarioId ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
      </div>

      <!-- Card Body -->
      <div *ngIf="expandedCardId === row.usuarioId" class="px-3 pb-3">
        <div class="grid grid-cols-2 gap-2 text-xs mb-3">
          <div class="col-span-2">
            <span style="color: #6b7280; font-weight: 600;">Email · RUT</span>
            <p class="break-all" style="color: #2563eb;">{{ row.email }}</p>
            <p class="font-mono text-gray-500" style="font-size: 0.7rem;">RUT {{ displayRut(row) }}</p>
          </div>
          <div *ngIf="isEmpresa(row) && row.razonSocial" class="col-span-2">
            <span style="color: #6b7280; font-weight: 600;">Razón social</span>
            <p style="color: #374151;">{{ row.razonSocial }}</p>
          </div>
          <div>
            <span style="color: #6b7280; font-weight: 600;">País</span>
            <p style="color: #374151;">{{ displayPais(row) }}</p>
            <p class="text-[10px] text-gray-500 mt-0.5"
              [title]="row.approvedAt ? 'Aprobado el ' + getDateFormatted(row.approvedAt) : 'Sin registro de aprobación en log'">
              Aprobado: {{ formatApprovalDate(row.approvedAt) }}
            </p>
          </div>

          <!-- Saldo USDT (cardex interno) — siempre visible -->
          <div class="col-span-2 mt-1">
            <span style="color: #6b7280; font-weight: 600;">Saldo USDT</span>
            <p class="font-mono"
              [style.color]="row.usdtBalance ? '#15803d' : '#9ca3af'"
              [style.fontWeight]="row.usdtBalance ? '700' : '400'">
              <ng-container *ngIf="row.usdtBalance !== null; else noUsdtMob">
                {{ formatUsd(row.usdtBalance) }} USDT
              </ng-container>
              <ng-template #noUsdtMob>Sin movimientos</ng-template>
            </p>
          </div>

          <!-- Prevalidación KYC interna: detalle + acción (badge ya
               aparece en el header del card, acá va lo que requiere
               espacio o interacción) -->
          <div *ngIf="!row.walletId" class="col-span-2 mt-1">
            <span style="color: #6b7280; font-weight: 600;">Prevalidación</span>
            <ng-container *ngIf="prevalidationBadge(row) as badge">
              <p class="text-[11px] text-gray-600 mt-1" style="margin: 4px 0 0 0;">{{ badge.tooltip }}</p>
              <button *ngIf="badge.canRevalidate"
                (click)="onRevalidateUser(row); $event.stopPropagation()"
                [disabled]="revalidatingUserId === row.usuarioId"
                [style.opacity]="revalidatingUserId === row.usuarioId ? '0.5' : '1'"
                style="display: inline-flex; align-items: center; gap: 4px; margin-top: 6px; padding: 6px 12px; font-size: 0.75rem; border: 1px solid #d1d5db; border-radius: 6px; background: white; color: #374151; cursor: pointer; font-weight: 600;">
                <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #374151;">refresh</mat-icon>
                {{ revalidatingUserId === row.usuarioId ? 'Validando...' : 'Prevalidar ahora' }}
              </button>
            </ng-container>
          </div>

          <ng-container *ngIf="row.walletId">
            <div class="col-span-2 mt-2 pt-2 border-t border-gray-100">
              <span style="color: #6b7280; font-weight: 600;">Sub-account ID</span>
              <p class="font-mono text-xs break-all" style="color: #2563eb;">{{ row.subAccountId }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">KYC</span>
              <p>
                <span class="px-2 py-0.5 inline-flex text-xs leading-5 font-bold rounded-full"
                  [style.background]="getKycStatusBg(row.kycStatus)"
                  [style.color]="getKycStatusColor(row.kycStatus)">
                  {{ row.kycStatus }}
                </span>
              </p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Balance BTC</span>
              <p class="font-mono" style="color: #1e5a3f; font-weight: 600;">{{ formatBtc(row.lastBalanceBtc) }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">USDT en sub</span>
              <p class="font-mono"
                [style.color]="hasPositiveSubUsdt(row) ? '#15803d' : (row.lastBalanceUsdt != null ? '#1e5a3f' : '#9ca3af')"
                [style.fontWeight]="hasPositiveSubUsdt(row) ? '700' : '500'">
                {{ formatUsd(row.lastBalanceUsdt) }} USDT
              </p>
            </div>
            <div class="col-span-2">
              <span style="color: #6b7280; font-weight: 600;">Último depósito</span>
              <p style="color: #374151; font-weight: 500;">
                <ng-container *ngIf="row.lastDepositAt; else noDepM">
                  {{ getRelativeTime(row.lastDepositAt) }}
                  <span title="Depósitos en las últimas 6 h">({{ row.totalDepositsCount }} recientes)</span>
                </ng-container>
                <ng-template #noDepM><span style="color: #9ca3af;">—</span></ng-template>
              </p>
            </div>
          </ng-container>
        </div>

        <!-- Acciones Mobile -->
        <div class="flex gap-2 pt-2 border-t border-gray-100">
          <!-- Sin wallet → solo crear -->
          <button *ngIf="!row.walletId" (click)="openCreateWalletModal(row); $event.stopPropagation()" class="flex-1"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 10px; border: 1px solid #1C593D; border-radius: 8px; background: #1C593D; color: white; cursor: pointer; font-size: 0.8rem; font-weight: 700;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: white;">add</mat-icon>
            Crear wallet Binance
          </button>

          <!-- Con wallet → acciones operativas -->
          <ng-container *ngIf="row.walletId">
            <button (click)="openDetail(row); $event.stopPropagation()" class="flex-1"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #bfdbfe; border-radius: 8px; background: #eff6ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #2563eb;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #2563eb;">visibility</mat-icon>
              Detalle
            </button>
            <button (click)="openDepositAddress(row); $event.stopPropagation()" class="flex-1"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #15803d;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #15803d;">qr_code_2</mat-icon>
              Dirección
            </button>
            <button (click)="openDepositsHistory(row); $event.stopPropagation()" class="flex-1"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #bae6fd; border-radius: 8px; background: #f0f9ff; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #0369a1;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #0369a1;">history</mat-icon>
              Depósitos
            </button>
            <button *ngIf="canRunManualCentralization(row)"
              (click)="openManualCentralizationModal(row); $event.stopPropagation()" class="flex-1"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #fde68a; border-radius: 8px; background: #fffbeb; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #d97706;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #d97706;">sync_alt</mat-icon>
              Centralizar
            </button>
            <button (click)="openDisableModal(row); $event.stopPropagation()" class="flex-1"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">block</mat-icon>
              Deshabilitar
            </button>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="users.length === 0" class="p-8 text-center text-gray-500 text-sm bg-white rounded-xl shadow-sm">
      No se encontraron usuarios con los filtros aplicados.
    </div>
  </div>

</div>
